/*!
 * Copyright (c) Microsoft Corporation. All rights reserved.
 */

import { Navbar, NavbarBrand, NavLink } from "react-bootstrap";

import { getTheme } from "office-ui-fabric-react";
import styled from "styled-components";

const theme = getTheme();

export const AdminNavbar = styled(Navbar)`
  background-color: #0066ff;
  padding: 1px;
  & .mscom-divider {
    padding-right: 15px;
  }
  & .mscom-siteLogo {
    padding-left: 10px;
  }
`;

export const AdminNavLink = styled(NavLink)`
  color: ${theme.palette.white} !important;
`;

export const AdminNavBrand = styled(NavbarBrand)`
  color: ${theme.palette.white} !important;
`;
